import { TextField } from "@ds/react";
import styled from "styled-components/macro";

export const InputContainer = styled.div(
  ({ error, half, width = "100%", theme, noMinWidth }) => ({
    width: "100%",
    position: "relative",

    [theme.breakpoint.lg()]: {
      maxWidth: half ? "50%" : "unset",
      minWidth: !noMinWidth && "300px",
      width: width,
    },

    'div[class^="TextFieldstyle__FooterContainer-sc"]': {
      margin: !error ? 0 : "5px 0",
    },

    ".loading-spinner": {
      position: "absolute",
      right: "16px",
      top: "calc(50% + 6px)",
      width: "16px",
      height: "16px",

      div: {
        borderColor: `${theme.color.brandPrimary.light} transparent transparent transparent`,
        borderWidth: "3px",
        width: "16px",
        height: "16px",
      },
    },
  })
);

export const Input = styled(TextField)({});
